<template>
	<v-main id="frontpage-container">
		<v-btn v-if="user" class="logout-btn" text @click="logout">
			<v-icon class="mr-1">mdi mdi-logout</v-icon>
			Log Out
		</v-btn>

        <v-btn v-if="$route.matched[1].props.default.backToLoginButton" class="backToLogin-btn" text @click="backToLogin">
            <v-icon class="mr-1">mdi mdi-logout</v-icon>
            Back to Login
        </v-btn>

		<v-row class="content">
			<v-col sm="4" class="sidebar">
				<v-img class="logo" :src="require('@/assets/logo.png')" />
			</v-col>

			<v-col sm="8" cols="12" class="main d-flex flex-column justify-center align-center py-15">
                <img class="frontpage-logo mb-1" src="/assets/media/images/site-logo-black-white-bg.png" />
                <span class="frontpage-title d-block text-center mb-9 narrow-container">{{ $route.matched[1].props.default.title }}</span>
                <span class="frontpage-subtitle d-block text-center mb-1 narrow-container" v-if="$route.matched[1].props.default.subtitle">{{ $route.matched[1].props.default.subtitle }}</span>
                <router-view />
			</v-col>
		</v-row>
	</v-main>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters("User", ["user"]),
	},

	methods: {
		logout() {
			this.$router.push({ name: "signout" });
		},

        backToLogin() {
            this.$router.push({ name: "login" });
        },
	},
};
</script>

<style lang="scss" scoped>
#frontpage-container {
	position: relative;

    * {
        font-family: Poppins !important;
    }

	.logout-btn {
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 99;
	}

    ::v-deep .v-input {
        .v-label {
            color: #7e7e7e;
        }
    }

    ::v-deep .v-btn__content {
        font-weight: 700;
    }

	.content {
		height: 100%;
        margin: 0;

		.sidebar {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
			background-color: #121212;

            @media (max-width: 575px) {
                display: none;
            }

			.logo {
				max-width: 40%;
			}
		}

		.main {
			height: 100%;
			background-color: white;
		}
	}
}

.backToLogin-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 99;
}
</style>

<style lang="scss">
.frontpage-logo {
    width: 80px;
    margin: 0 auto;
    display: block;
}

.frontpage-title {
    font-size: 22px;
    font-weight: 600;
    line-height: 1.25;
}

.frontpage-subtitle {
    font-size: 14px;
    color: #666;
    line-height: 1.25;
}

.narrow-container {
    max-width: 530px;
}

.frontpage-text,
.frontpage-link {
    color: #666 !important;
    font-size: 14px;
}

.v-select-list {
    box-shadow: 0 0 0 0 rgb(0 0 0 / 10%), 0 0 0 0 rgb(0 0 0 / 7%), 0 0 0 0 rgb(0 0 0 / 6%) !important;

    .v-list-item__title {
        font-family: Poppins;
        font-size: 14px;
        color: #666;
    }
}
</style>
